module.exports = __webpack_public_path__ + "static/media/iconMoneyLimit.cb500db0.svg";